<template>
    <div class="sign">
        <div class="errorMsg" style="text-align:left;margin-top:10px;padding-left:65px;">
            {{errorMsg}}
        </div>
        <div class="input-img-code">
            <input type="text" v-model="imgCode.code" maxlength="4" placeholder="输入图形验证码">
            <img :src="'data:image/jpg;base64,'+imgCode.value" alt="" v-if="imgCode.value">
        </div>
        <p>
            <a href="javascript:void(0)" @click="refreshImgCode" class="underline-href" style="color: #6C6F70;">看不清？点我刷新！</a>
        </p>
        <div style="padding-bottom:30px;">
            <button type="button" class="main-btn" @click="submit()" style="width:230px;">确定</button>
        </div>
    </div>
</template>
<script>
    import api from '../../../api';
    export default{
        props:{
            phone:{
                required:true
            }
        },
        data(){
            return {
                imgCode:{
                    code:'',
                    key:'',
                    value:'',
                    type:''
                },
                errorMsg:'',
            }
        },
        methods:{
            refreshImgCode(){
                api.account.getCaptcha()
                    .then((res)=>{
                        this.imgCode.code='';
                        this.errorMsg='';
                        this.imgCode.value = res.value;
                        this.imgCode.key = res.key;
                    });
            },
            open(type){
//                type=='login'?this.type=3:this.type=4;
                if(type === 'realName'){
                    this.type = 5;
                }else if(type==='login'){
                    this.type = 3;
                }else{
                    this.type = 4;
                }
                this.refreshImgCode();
            },
            submit(){
                if(!this.imgCode.code){
                    this.errorMsg = '请输入图形验证码';
                }else{
                    api.account.code_verfy_new({
                        key:this.imgCode.key,
                        code:this.imgCode.code,
                        phone:this.phone,
                        messageType: this.type
                    })
                        .then((res)=>{
                            if(res){
                                this.imgCode.value = res.value;
                                this.imgCode.key = res.key;
                                this.$emit('sendMsg');
                            }else{
                                this.errorMsg = '图形验证码错误';
                            }
                        });
                }
            }
        }
    }
</script>
<style>
    .imgValidator .ivu-modal-mask{
        z-index:1001;
    }
    .imgValidator .ivu-modal-wrap{
        z-index:1001;
    }
    .imgValidator .ivu-modal{
        top:310px;
    }
    .imgValidator .ivu-modal-body{
        padding:26px 65px 50px;
    }
    .imgValidator .ivu-modal-footer{
        display:none;
    }
    .imgValidator .ivu-modal-header{
        text-align:center;
        height:56px;
        font-size:16px;
        padding:0;
        line-height:56px;
    }
    .imgValidator .input-img-code{
        height:44px;
        line-height:44px;
    }
    .imgValidator .input-img-code input{
        display:inline-block;
        width:120px;
        height:40px;
        border: 0 none;
        border-radius: 100px;
        text-align:center;
        background: #F2F4F5;
    }
    .imgValidator .input-img-code img{
        width:100px;
        height:38px;
        display:inline-block;
        margin-left:6px;
        vertical-align: middle;
    }
    .imgValidator .ivu-modal-body p{
        text-align:center;
        margin:18px 0;
    }
    .imgValidator .ivu-modal-body div{
        text-align:center;
    }
    .imgValidator .ivu-modal-body div button{
        width:230px;
    }
</style>
